import { render, staticRenderFns } from "./PositionAndMarginBehindReport.vue?vue&type=template&id=65d00e8c&scoped=true"
import script from "./PositionAndMarginBehindReport.vue?vue&type=script&lang=js"
export * from "./PositionAndMarginBehindReport.vue?vue&type=script&lang=js"
import style0 from "./PositionAndMarginBehindReport.vue?vue&type=style&index=0&id=65d00e8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d00e8c",
  null
  
)

export default component.exports